<div class="fc-detail-form">
  <div class="fc-detail-form-header">
    <span class="material-icons fc-detail-form-icon">business</span>
    <h3 class="fc-detail-form-title">{{ customerForm.controls.id.value ? 'Edit Customer' : 'Add Customer' }}</h3>
  </div>

  <form [formGroup]="customerForm" (ngSubmit)="onSubmit()" class="fc-form-grid">
    <input formControlName="id" type="hidden" />

    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="customerForm.controls?.name?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Address</mat-label>
      <input matInput formControlName="address" required />
      <mat-error *ngIf="customerForm.controls?.address?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>City</mat-label>
      <input matInput formControlName="city" required />
      <mat-error *ngIf="customerForm.controls?.city?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" required email />
      <mat-error *ngIf="customerForm.controls.email.hasError('email')">Invalid email address</mat-error>
      <mat-error *ngIf="customerForm.controls.email.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Country</mat-label>
      <mat-select formControlName="country" (selectionChange)="preapreTmz()">
        <mat-option *ngFor="let item of countries" [value]="item.id">{{ item.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Timezone</mat-label>
      <mat-select formControlName="timeZone">
        <mat-option *ngFor="let item of tmzs" [value]="item.name">{{ item.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="fc-field-full">
      <ngx-mat-file-input formControlName="imageBin" accept="image"></ngx-mat-file-input>
      <mat-hint>Image/logo [max {{ imgaMaxSize }} Mb]</mat-hint>
      <mat-error *ngIf="customerForm.controls.imageBin.hasError('maxSize')">File too large</mat-error>
    </mat-form-field>

    <mat-checkbox *ngIf="customerForm.controls?.id" class="fc-field-full" formControlName="deleteImg">Delete image</mat-checkbox>

    <div class="fc-form-actions">
      <button type="reset" class="fc-btn fc-btn--ghost" (click)="clear()">Clear</button>
      <button type="submit" class="fc-btn fc-btn--primary" [disabled]="!customerForm.valid">Save</button>
    </div>
  </form>
</div>
